import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20collage%20of%20fashion%20silhouettes%20with%20soft%20geometric%20shapes%20in%20muted%20terracotta%20sage%20green%20and%20warm%20sand%20tones%2C%20dreamy%20ethereal%20composition%20with%20translucent%20layers%2C%20modern%20minimalist%20art%20direction%2C%20textured%20paper%20effect%2C%20sophisticated%20editorial%20design&width=1920&height=1080&seq=hero-bg-v2-07&orientation=landscape"
          alt="CSSBuy Spreadsheet abstract fashion art"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left content */}
          <div className="flex-1 text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-6">
              <i className="ri-sparkling-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
              <span>Updated Daily for 2026</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              CSSBuy Spreadsheet
              <br />
              <span className="text-primary-600">Hub 2026</span>
            </h1>
            <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-500 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              Your go-to destination for verified CSSBuy spreadsheet finds, Kakobuy spreadsheets, Superbuy spreadsheets, and Oopbuy spreadsheets. Compare products, prices, and trusted agent links all in one place.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
            {/* Trust mini badges */}
            <div className="mt-8 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                <span>Verified Links</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                <span>Daily Updates</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-global-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                <span>14 Categories</span>
              </div>
            </div>
          </div>

          {/* Right preview cards */}
          <div className="hidden lg:flex flex-1 justify-end">
            <div className="grid grid-cols-2 gap-4 w-full max-w-md">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="group relative rounded-2xl overflow-hidden aspect-square bg-background-200 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=White%20chunky%20designer%20sneakers%20on%20dark%20polished%20concrete%20floor%20with%20dramatic%20side%20shadow%20play%2C%20urban%20street%20photography%20style%2C%20contrasting%20light%20and%20dark%2C%20clean%20product%20shot%20with%20edge%2C%20modern%20industrial%20aesthetic&width=600&height=600&seq=hero-shoes-v2&orientation=squarish"
                  alt="Shoes category"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-semibold">Shoes</span>
              </a>
              <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="group relative rounded-2xl overflow-hidden aspect-square bg-background-200 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Cognac%20leather%20tote%20bag%20placed%20on%20white%20marble%20surface%20next%20to%20a%20lush%20monstera%20plant%2C%20bright%20morning%20sunlight%20streaming%20through%20window%2C%20fresh%20botanical%20vibe%2C%20premium%20product%20photography%2C%20elegant%20lifestyle%20composition&width=600&height=600&seq=hero-bags-v2&orientation=squarish"
                  alt="Bags category"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-semibold">Bags</span>
              </a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="group relative rounded-2xl overflow-hidden aspect-square bg-background-200 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Charcoal%20gray%20oversized%20hoodie%20hanging%20on%20wooden%20hanger%20against%20a%20textured%20white%20plaster%20wall%2C%20Scandinavian%20minimalist%20interior%20style%2C%20soft%20diffused%20lighting%20from%20above%2C%20clean%20architectural%20photography%2C%20simple%20elegant%20composition&width=600&height=600&seq=hero-hoodie-v2&orientation=squarish"
                  alt="Hoodies category"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-semibold">Hoodies</span>
              </a>
              <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="group relative rounded-2xl overflow-hidden aspect-square bg-background-200 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Rose%20gold%20watch%20and%20braided%20leather%20bracelet%20resting%20on%20dark%20slate%20stone%20surface%2C%20moody%20atmospheric%20lighting%20with%20warm%20highlights%2C%20luxury%20product%20photography%2C%20rich%20textures%20and%20contrasts%2C%20sophisticated%20jewelry%20editorial&width=600&height=600&seq=hero-accessories-v2&orientation=squarish"
                  alt="Accessories category"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-semibold">Accessories</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}